import { render, staticRenderFns } from "./PortalTextarea.vue?vue&type=template&id=8283ddde&scoped=true&"
import script from "./PortalTextarea.vue?vue&type=script&lang=ts&"
export * from "./PortalTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8283ddde",
  null
  
)

export default component.exports